import Skeleton, { SkeletonProps } from "@mui/material/Skeleton";
import { TypographyProps } from "@mui/material/Typography";
import { forwardRef } from "react";

export const TextFieldSkeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  (propsToSkeleton, ref) => (
    <Skeleton
      ref={ref}
      variant="rounded"
      {...propsToSkeleton}
      sx={{ height: "3.75rem", width: "100%", ...propsToSkeleton.sx }}
    />
  )
);

export const ButtonSkeleton = forwardRef<HTMLDivElement, SkeletonProps>((propsToSkeleton, ref) => (
  <Skeleton
    ref={ref}
    variant="rounded"
    {...propsToSkeleton}
    sx={{ height: "3rem", width: "100%", ...propsToSkeleton.sx }}
  />
));

export const TypographySkeleton = forwardRef<
  HTMLDivElement,
  Omit<SkeletonProps, "variant"> & {
    variant?: TypographyProps["variant"];
    lines?: number;
    onDark?: boolean;
  }
>(({ variant, lines = 1, onDark, ...propsToSkeleton }, ref) => (
  <Skeleton
    ref={ref}
    variant="rounded"
    {...propsToSkeleton}
    sx={{
      height: `calc(1.45rem * ${lines})`,
      width: "100%",
      ...(onDark && {
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      }),
      ...propsToSkeleton.sx,
    }}
  />
));
